// import React from 'react';
// import loadable from '@loadable/component';

// const OffersListingPageComponent = (props) => {
//   const Component = loadable(() => import('./OffersListingPageComponent.js'), { ssr: false });
//   return <Component {...props} />;
// };

// export default OffersListingPageComponent;

import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import './style.scss';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import SearchComponent from './Search';
import FilterComponent from './Filter';
import OfferCardGridItemComponent from '../OfferCardGridItemComponent';
import { withTranslation } from 'react-i18next';
import PaginationComponent from './Pagination';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import useSliderRange from './SliderRange/useSliderRange';
import ResultsNotFound from './ResultsNotFound';
import helpers from './helpers/index.js';
import Button from '../Shared/components/controls/Button';
import useWindowSize from '../Shared/hooks/useWindowSize';
import { useHistory } from 'react-router-dom';
import { loader as gqlLoader } from 'graphql.macro';
import { useQuery } from 'react-apollo';
const query = gqlLoader('./API/offerListing.graphql'); //query code
/***Component***/
const OffersListingPageComponent = (props) => {
  const history = useHistory();

  const setPageQueryString = (page, item) => {
    history.push({ search: `page=${page}&item=${item}` });
  };

  const [width] = useWindowSize();
  var isMobile = false;
  if (width > 768) {
    isMobile = false;
  } else {
    isMobile = true;
  }
  //language
  const { t, i18n, params } = props;
  const {
    min: minDiscount,
    max: maxDiscount,
    divisionsForDiscount,
    enableDiscountPercentage,
    endDate,
    maxInputAdornmentText,
    maxInputLabel,
    minInputPlaceholder,
    maxInputPlaceholder,
    minInputAdornmentText,
    minInputLabel,
    indexName: INDEX_NAME,
    //no result page
  } = props?.fields;
  const language = i18n.language;
  //constants
  const pageSizes = props?.fields?.pageSizes;
  const context = useSitecoreContext();
  const offerCategoryId = context?.sitecoreContext?.route?.fields?.offerCategory?.id?.replace(
    /-/g,
    ''
  ) || ''; //get id but remove hyphens for the query
  const offerCategoryName = context?.sitecoreContext?.route?.fields?.offerCategory?.name; //get name of the pagae category to show it under the search
  const defaultPageSize = props?.fields?.defaultPageSize; //default page size { value: 2 }; //
  const [selectSortValue, setSelectSortValue] = useState('');
  const [selectSortText, setSelectSortText] = useState(t('selectOption'));
  const [numberOfFilters, setNumberOfFilters] = useState(0);
  const [dataRetrieved, setDataRetrieved] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    itemsPerPage: defaultPageSize.value,
    pagesTotalNumber: 1,
    hasNext: false,
    hasPrevious: false,
    itemsCount: 0,
  });
  const [resetSliderRangeDiscount, setResetSliderRangeDiscount] = useState(false);
  const [mobileFiltersIsToggle, setMobileFiltersIsToggle] = useState(false);

  var year = new Date().getFullYear();
  var month = new Date().getMonth();
  let firstOfThisMonthDate = new Date(year, month, 1);

  // All filters
  const [allFilters, setAllFilters] = useState({
    //filtering
    cuisineFilter: [],
    cardsFilter: [],
    offerTagsFilter: [],
    locationFilter: [],
    tagFilter: [],
    discountFilter: { from: minDiscount?.value, to: maxDiscount?.value },
    validityFilter: { from: firstOfThisMonthDate, to: endDate }, //date format:2021-12-31T16:00:00Z
    selectedLocationsIDForGraphGql: [],
    selectedCuisineIDForGraphGql: [],
    selectedOfferTagsIDForGraphGql: [],
    selectedCardsIDForGraphGql: [],
    //sorting
    sortBy: '',
    //search
    keyword: '',
    minDiscount: minDiscount?.value,
    maxDiscount: maxDiscount?.value,
    validityFilterStartDate: firstOfThisMonthDate,
    validityFilterEndDate: endDate,
    reRender: true,
    filtersCount: 0,
  });

  let labels = {
    minInputAdornmentText,
    maxInputAdornmentText,
    minInputPlaceholder,
    maxInputPlaceholder,
    minInputLabel,
    maxInputLabel,
  };
  //sliderDiscountPercentageRange
  const sliderDiscountPercentageRange = useSliderRange(
    minDiscount,
    maxDiscount,
    divisionsForDiscount,
    labels,
    setAllFilters
  );

  //END: date range
  //index name for the query

  let indexName = INDEX_NAME?.value || 'FAB2_offers_#database#_index';
  indexName = indexName.replace('#database#', context?.sitecoreContext?.route?.databaseName);

  //related to building the variable when filtering
  const [filterVariable, setFilterVariable] = useState({
    index: indexName,
    first: defaultPageSize.value,
    after: '0',
    fieldsEqual: [
      { name: '_templatename', value: 'Offer Detail' },
      { name: 'offerCategories', value: offerCategoryId },
    ],
  });

  const { data } = useQuery(query, {
    variables: filterVariable,
    onCompleted: () => {
      setDataRetrieved(true);
    },
  });
  //added start
  var search = typeof window !== 'undefined' ? window?.location?.search?.split('?page=')[1] : '';
  var currentPage = !!search?.split('&')[0] ? search?.split('&')[0] : 1;
  var itemsPerPage = !!search?.split('&')[1]?.split('item=')[1]
    ? search?.split('&')[1]?.split('item=')[1]
    : defaultPageSize.value;
  var items = data?.search?.results?.items;
  const totalItemsCount = data?.search?.results?.totalCount;
  var hasNext = false;
  var hasPrevious = false;
  var pagesTotalNumberVar = -1;

  useEffect(() => {
    //get pagination from query string

    if (Array.isArray(items) && items?.length > 0) {
      pagesTotalNumberVar =
        totalItemsCount / itemsPerPage < 1 ? 1 : Math.ceil(totalItemsCount / itemsPerPage);

      if (pagesTotalNumberVar > currentPage) {
        hasNext = true;
      }
      if (currentPage > 1) {
        hasPrevious = true;
      }
    }

    setPagination((prev) => {
      return {
        ...prev,
        currentPage: currentPage,
        itemsCount: totalItemsCount,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        itemsPerPage: itemsPerPage,
        pagesTotalNumber: pagesTotalNumberVar === -1 ? 1 : pagesTotalNumberVar,
      };
    });
  }, [data]);
  //added end
  useEffect(() => {
    helpers({
      allFilters,
      firstOfThisMonthDate,
      setFilterVariable,
      indexName,
      language,
      pagination,
      offerCategoryId,
      isMobile,
      setNumberOfFilters,
    });
  }, []);

  useEffect(() => {
    const { keyword } = { ...allFilters };

    helpers({
      allFilters,
      firstOfThisMonthDate,
      setFilterVariable,
      indexName,
      language,
      pagination,
      offerCategoryId,
      keyword,
      isMobile,
      setNumberOfFilters,
    });
  }, [
    allFilters,
    pagination?.itemsPerPage,
    pagination?.currentPage,
    allFilters?.reRender,
    numberOfFilters,
  ]);

  //events

  //reset the filters and tags on click of the button in the not found results
  const handleResetFiltersCallback = () => {
    setAllFilters((prev) => {
      return {
        ...prev,
        cuisineFilter: [],
        cardsFilter: [],
        offerTagsFilter: [],
        locationFilter: [],
        tagFilter: [],
        discountFilter: { from: minDiscount?.value, to: maxDiscount?.value },
        validityFilter: {
          from: firstOfThisMonthDate.toISOString(),
          to: endDate,
        },
        //date format:2021-12-31T16:00:00Z
        selectedLocationsIDForGraphGql: [],
        selectedCuisineIDForGraphGql: [],
        selectedOfferTagsIDForGraphGql: [],
        selectedCardsIDForGraphGql: [],
        validityFilterEndDate: endDate,
        filtersCount: prev.filtersCount - 1,
      };
    });

    setResetSliderRangeDiscount((prev) => !prev);
  };

  //on change of the dropdown of items per page
  const handleSelectedItemsPerPageChange = (event) => {
    let itemsPerPageDropdownValue = parseInt(event.target.value);

    pagesTotalNumberVar =
      totalItemsCount / itemsPerPageDropdownValue < 1
        ? 1
        : Math.ceil(totalItemsCount / itemsPerPageDropdownValue);
    if (pagesTotalNumberVar > pagination?.currentPage) {
      hasNext = true;
    }
    if (pagination?.currentPage > 1) {
      hasPrevious = true;
    }

    setPagination((prev) => {
      return {
        ...prev,
        currentPage: 1,
        itemsCount: totalItemsCount,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        itemsPerPage: itemsPerPageDropdownValue,
        pagesTotalNumber: pagesTotalNumberVar,
        itemsCount: totalItemsCount,
      };
    });
    setPageQueryString(1, itemsPerPageDropdownValue);
  };
  function handleClick() {
    history.goBack();
  }
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="OffersListingPageComponent" />;
  }
  //return data
  return (
    <div className="OfferCategoryListingSection">
      <div className="content">
        <Button
          className="back"
          onClick={handleClick}
          color="primary"
          variant="text"
          arrow="left"
          fullWidth={false}
        >
          {t('Back')}
        </Button>

        <SearchComponent
          {...{
            props,
            allFilters,
            firstOfThisMonthDate,
            offerCategoryName,
            indexName,
            language,
            offerCategoryId,
            setAllFilters,
            pagination,
            t,
            count: totalItemsCount,
            selectSortValue,
            setSelectSortValue,
            selectSortText,
            setSelectSortText,
            mobileFiltersIsToggle,
            setMobileFiltersIsToggle,
            isMobile,
            numberOfFilters,
            setNumberOfFilters,
          }}
        />
        <FilterComponent
          {...{
            props,
            t,
            setAllFilters,
            allFilters,
            selectSortValue,
            setSelectSortValue,
            selectSortText,
            setSelectSortText,
            sliderProps: sliderDiscountPercentageRange?.sliderProps,
            enableDiscountPercentage,
            minDiscount,
            maxDiscount,
            externalReset: resetSliderRangeDiscount,
            mobileFiltersIsToggle,
            setMobileFiltersIsToggle,
            setNumberOfFilters,
            firstOfThisMonthDate,
            offerCategoryName,
            indexName,
            language,
            offerCategoryId,
            setFilterVariable,
            isMobile,
          }}
        />
        <div
          className={clsx('offer-card-grid-items flex-it flex-wrap', 'add-margins', params?.Styles)}
        >
          {dataRetrieved &&
            Array.isArray(items) &&
            items?.length > 0 &&
            items?.map((card, iCard) => {
              return (
                <OfferCardGridItemComponent
                  item={{ fields: { ...card?.item } }}
                  key={iCard}
                  lang={language}
                  fromGraphql
                  t={t}
                />
              );
            })}

          {dataRetrieved && items?.length <= 0 && (
            <ResultsNotFound
              props={props}
              name={offerCategoryName}
              reset={handleResetFiltersCallback}
            />
          )}
        </div>
        {totalItemsCount > 0 && (
          <PaginationComponent
            onChange={handleSelectedItemsPerPageChange}
            pagination={pagination}
            allFilters={allFilters}
            pageSizes={pageSizes}
            setPagination={setPagination}
            t={t}
          />
        )}
      </div>
    </div>
  );
};

export default withTranslation()(OffersListingPageComponent);
